import { captureException } from '../../utils/sentryAPI';
export function isInIframe() {
  try {
    return window.parent !== window.self;
  } catch (e) {
    captureException(e);
    return true;
  }
}